import React from 'react';
import { DateTimePicker, DropdownList } from 'react-widgets';
import classNames from 'classnames';
import styles from './assets/changeComponent.module.scss';

interface PropsTime {
    action: (date: any, dateStr: any, act: any) => void;
    className?: AnyObject | string;
    dataList?: any;
    noEdit: boolean;
    setOpenDrop?: any;
    value?: any;
    time?: boolean;
    date?: boolean;
    min?: any;
    step?: number;
    format?: string;
    max?: any;
    data?: any;
}

const ChangeComponentTime: React.FunctionComponent<PropsTime> = ({
    data,
    date,
    noEdit,
    action,
    format,
    step,
    setOpenDrop,
    time,
    min,
    max,
    value,
}: PropsTime) => {
    const [isActive, setActive] = React.useState(false);
    const [dataIn, setData] = React.useState(data);
    const [valueIn, setValue] = React.useState(value);
    const actionChange = (date: any, valueD: any) => {
        setData(date);
        setValue(valueD);
    };
    if (isActive) {
        return (
            <div style={{ maxWidth: '200px', display: 'table-caption', position: 'relative' }}>
                <div onClick={() => setActive(!isActive)} className={classNames(styles.activeOff)}></div>
                <div className={classNames(styles.wrapField)}>
                    <DateTimePicker
                        onChange={(date: any, dateStr: any) => {
                            action(date, dateStr, actionChange);
                            setActive(!isActive);
                        }}
                        onToggle={(isOpen) => {
                            if (isOpen) {
                                setOpenDrop(true);
                            } else {
                                setOpenDrop(false);
                            }
                        }}
                        value={valueIn}
                        time={time}
                        date={date}
                        dropUp
                        min={min}
                        max={max}
                        step={step}
                        format={format}
                    />
                </div>
            </div>
        );
    }

    return (
        <div
            onClick={() => {
                if (!noEdit) {
                    setActive(!isActive);
                }
            }}
            style={noEdit ? {} : { cursor: 'pointer', minWidth: '100px' }}
        >
            {dataIn}
        </div>
    );
};
interface Props {
    action: (date: any, act: (date: any, valueD: any) => void) => void;
    className?: AnyObject | string;
    dataList?: any;
    setOpenDrop?: any;
    noEdit: any;

    value?: any;
    time?: boolean;
    date?: boolean;
    min?: any;
    step?: number;
    format?: string;
    max?: any;
    data?: any;
}
const ChangeComponentSelect: React.FunctionComponent<Props> = ({
    dataList,
    data,
    noEdit,
    action,
    setOpenDrop,
    value,
}: Props) => {
    const [isActive, setActive] = React.useState(false);
    const [dataIn, setData] = React.useState(data);
    const [valueIn, setValue] = React.useState(value ? value : undefined);
    const actionChange = (date: any, valueD: any) => {
        setData(date);
        setValue(valueD);
    };
    if (isActive) {
        return (
            <div style={{ maxWidth: '200px', display: 'table-caption', position: 'relative' }}>
                <div onClick={() => setActive(!isActive)} className={classNames(styles.activeOff)}></div>
                <div className={classNames(styles.wrapField)}>
                    <DropdownList
                        data={[{ label: 'All', value: '' }, ...dataList]}
                        textField="label"
                        valueField="value"
                        onChange={(data) => {
                            action(data, actionChange);
                            setActive(!isActive);
                        }}
                        value={valueIn}
                        onToggle={(isOpen) => {
                            if (isOpen) {
                                setOpenDrop(true);
                            } else {
                                setOpenDrop(false);
                            }
                        }}
                    />
                </div>
            </div>
        );
    }

    return (
        <div
            onClick={() => {
                if (!noEdit) {
                    setActive(!isActive);
                }
            }}
            style={noEdit ? {} : { cursor: 'pointer', minWidth: '100px' }}
        >
            {dataIn}
        </div>
    );
};
interface PropsField {
    action: (date: any, act: (date: any, valueD: any) => void) => void;
    className?: AnyObject | string;
    noEdit: boolean;
    value?: any;
    data?: any;
}
const ChangeComponentField: React.FunctionComponent<PropsField> = ({ data, action, noEdit, value }: PropsField) => {
    const [isActive, setActive] = React.useState(false);
    const [dataIn, setData] = React.useState(data);
    const [valueIn, setValue] = React.useState(value);
    const actionChange = (date: any, valueD: any) => {
        setData(date);
        setValue(valueD);
    };
    if (isActive) {
        return (
            <div style={{ maxWidth: '200px', display: 'table-caption', position: 'relative' }}>
                <div
                    onClick={() => {
                        if (dataIn !== valueIn) {
                            action(valueIn, actionChange);
                        }
                        setActive(!isActive);
                    }}
                    className={classNames(styles.activeOff)}
                ></div>
                <div className={classNames(styles.wrapField)}>
                    <input
                        type="text"
                        className={classNames('form-control', 'input-sm')}
                        onChange={(event) => {
                            setValue(event.target.value);
                        }}
                        value={valueIn}
                    />
                </div>
            </div>
        );
    }

    return (
        <div
            onClick={() => {
                if (!noEdit) {
                    setActive(!isActive);
                }
            }}
            style={noEdit ? {} : { cursor: 'pointer', minWidth: '100px', minHeight: 30 }}
        >
            {dataIn}
        </div>
    );
};

export { ChangeComponentTime, ChangeComponentSelect, ChangeComponentField };
